import React from 'react';
import PropTypes from 'prop-types';
import TopicsItem from './TopicsItem';

const TopicsList = ({ topics, words }) => {
    if (topics.length !== 0) {
        return (
            <>
            <div className="KeywordMatchList" id="KeywordMatch">
                <div className="Title">
                    <span>{words}</span>に関連するコンテンツ
                </div>
                <ul className="ListMedium">
                { topics.map((topic, index) => <TopicsItem key={index} {...topic}/>)}
                </ul>
            </div>
            </>
            );
    }
    return null;
}
// PostListのpropについて、型定義
TopicsList.propTypes = {
    topics: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string,
        }).isRequired
    ).isRequired
}

export default TopicsList;